import axios from "axios";
import config from "../config";

const url = () => {
    // return 'https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1'
    return config.commonApiEndPoint
}

const fetchClient = () => {
    console.log('url() common => ', process.env)
    const defaultOptions = {
        baseURL: url(),
    };

    // Create instance
    const instance = axios.create(defaultOptions);

    // Set the AUTH token for any request
    instance.interceptors.request.use(function (config) {
        // config.headers.authorization = token ? `Bearer ${token}` : "";
        // config.headers.apiKey = apiKeyNews()
        return config;
    });

    return instance;
};

export default fetchClient();
